import { HttpInterceptors } from "./http.interceptor";

export class UsersService extends HttpInterceptors {
	async listUsers (filters) {
		const response = await this.axios.get("users/listUsers", { params: { filters }});
		return response.data;
	}

	async upsertUser (payload) {
		const response = await this.axios.post("users/upsertUser", payload);
		return response.data;
	}

	async deleteUser (id) {
		const response = await this.axios.delete("users/deleteUser", { params: id });
		return response.data;
	}

	async updateProfile (payload) {
		const response = await this.axios.post("users/updateProfile", payload);
		return response.data;
	}

	async getAllUsersSubscriptionRequired () {
		const response = await this.axios.get("users/getAllUsersSubscriptionRequired");
		return response.data;
	}

	async getUserByIdUser (idUser) {
		const response = await this.axios.get("users/getUserByIdUser", { params: idUser });
		return response.data;
	}
}
